'use strict';

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

module.exports = boundary;

function boundary(cells) {
  var i, j, k;
  var n = cells.length;
  var sz = 0;

  for (i = 0; i < n; ++i) {
    sz += cells[i].length;
  }

  var result = new Array(sz);
  var ptr = 0;

  for (i = 0; i < n; ++i) {
    var c = cells[i];
    var d = c.length;

    for (j = 0; j < d; ++j) {
      var b = result[ptr++] = new Array(d - 1);
      var p = 0;

      for (k = 0; k < d; ++k) {
        if (k === j) {
          continue;
        }

        b[p++] = c[k];
      }

      if (j & 1) {
        var tmp = b[1];
        b[1] = b[0];
        b[0] = tmp;
      }
    }
  }

  return result;
}

;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(boundary, "boundary", "/home/yatham/Dev_BHS_Portal/node_modules/boundary-cells/boundary.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();